import { Button, TextField, Typography } from '@mui/material';
import React from 'react';
import { ViewContainer } from './containers';

const ProfileView = () => {
    return (
        <ViewContainer>
            <Typography variant="h3">Profile View</Typography>
            <div className="card">
                <div className="header">
                    <Typography>Personal Details</Typography>
                    <Button>Save changes</Button>
                </div>
                <Typography className="section-title">Full name</Typography>
                <form className="name-input" noValidate autoComplete="off">
                    <TextField id="outlined-basic" label="full name" variant="outlined" />
                </form>
                <Typography className="section-title">Email</Typography>
                <form className="email-input" noValidate autoComplete="off">
                    <TextField id="outlined-basic" label="email" variant="outlined" />
                </form>
                <Typography className="section-title">Password</Typography>
                <Button className="password-button">Change Password</Button>
            </div>
        </ViewContainer>
    );
};

export default ProfileView;
